var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { ShiftIntervalCategory } from '@amzn/atoz-shiftapp-types';
import { getTimeIntervalStr } from '@amzn/atoz-shiftapp-utilities';
import { DateTime } from 'luxon';
import { useDynamicTranslation } from '../../../../hooks/useDynamicTranslation';
import { gql } from '@apollo/client';
import { logger } from '@amzn/atoz-shiftapp-metrics';
export var SHIFT_INTERVAL_BLOCK_ERROR_PREFIX = 'ShiftIntervalBlockError:';
export var useShiftIntervalBlockData = function (_a) {
    var category = _a.category, timeRange = _a.timeRange, name = _a.name, skill = _a.skill;
    var dt = useDynamicTranslation().dt;
    var intervalTimeRange = React.useMemo(function () {
        return getTimeIntervalStr(DateTime.fromISO(timeRange.start), DateTime.fromISO(timeRange.end));
    }, [timeRange.start, timeRange.end]);
    var intervalSkill = skill ? dt(skill) : undefined;
    var blockName = dt(name);
    var blockContent = intervalSkill
        ? "".concat(intervalSkill, " ").concat(intervalTimeRange)
        : "".concat(intervalTimeRange);
    if (!Object.values(ShiftIntervalCategory).includes(category)) {
        logger.error("".concat(SHIFT_INTERVAL_BLOCK_ERROR_PREFIX, " category ").concat(category, " is unknown"), {
            timeRange: "".concat(timeRange.start, " - ").concat(timeRange.end)
        });
    }
    return {
        blockName: blockName,
        blockContent: blockContent
    };
};
useShiftIntervalBlockData.fragments = {
    shiftIntervals: gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        fragment UseShiftIntervalBlockData_ShiftInterval on ShiftInterval {\n            category\n            name {\n                defaultText\n                namespace\n                translationKey\n            }\n            skill {\n                defaultText\n                namespace\n                translationKey\n            }\n            timeRange {\n                start\n                end\n            }\n        }\n    "], ["\n        fragment UseShiftIntervalBlockData_ShiftInterval on ShiftInterval {\n            category\n            name {\n                defaultText\n                namespace\n                translationKey\n            }\n            skill {\n                defaultText\n                namespace\n                translationKey\n            }\n            timeRange {\n                start\n                end\n            }\n        }\n    "])))
};
var templateObject_1;
